/**
 * Madesa Help Button
 * Handles the help button interactions and analytics tracking
 */

document.addEventListener('DOMContentLoaded', function() {
  const helpButtons = document.querySelectorAll('.madesa-help-button');
  let blipInitialized = false;

  // Function to initialize Blip Chat (only once)
  function initBlipChat() {
    if (blipInitialized || typeof BlipChat === 'undefined') return;
    
    try {
      new BlipChat()
        .withAppKey('bWFkZXNhcm90ZWFkb3I6MDNiOGMzOTItZTc1NC00YzMzLWI5NzItYzU4OGU3NDkyZWEw')
        .withButton({"color":"#E11923","icon":"https://blipmediastore.blob.core.windows.net/public-medias/Media_939f7650-5a72-4527-984d-b90c40aeea14"})
        .withCustomCommonUrl('https://madesa.chat.blip.ai/')
        .build();
      
      blipInitialized = true;
    } catch (error) {
      console.error('Erro ao inicializar Blip Chat:', error);
    }
  }

  helpButtons.forEach(function(container) {
    const toggleBtn = container.querySelector('.madesa-help-button__toggle');
    const content = container.querySelector('.madesa-help-button__content');
    const options = container.querySelectorAll('.madesa-help-button__option');
    const submenu = container.querySelector('.madesa-help-button__submenu');
    const submenuTrigger = container.querySelector('[data-action="toggle-submenu"]');
    const submenuBack = container.querySelector('[data-action="close-submenu"]');

    if (!toggleBtn || !content) return;

    // Toggle menu
    function toggleMenu() {
      const isOpen = container.classList.contains('is-open');
      
      if (isOpen) {
        // Close menu
        container.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-label', 'Abrir menu de ajuda');
        content.setAttribute('aria-hidden', 'true');

        // Track analytics
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'help_button_closed',
            'button_location': 'floating'
          });
        }
      } else {
        // Open menu
        container.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.setAttribute('aria-label', 'Fechar menu de ajuda');
        content.setAttribute('aria-hidden', 'false');

        // Track analytics
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'help_button_opened',
            'button_location': 'floating'
          });
        }
      }
    }

    // Toggle submenu
    function toggleSubmenu() {
      if (!submenu) return;
      
      const isOpen = submenu.classList.contains('is-open');
      
      if (isOpen) {
        submenu.classList.remove('is-open');
        submenuTrigger.setAttribute('aria-expanded', 'false');
        submenu.setAttribute('aria-hidden', 'true');
      } else {
        submenu.classList.add('is-open');
        submenuTrigger.setAttribute('aria-expanded', 'true');
        submenu.setAttribute('aria-hidden', 'false');
      }
    }

    // Event listeners
    toggleBtn.addEventListener('click', toggleMenu);

    if (submenuTrigger) {
      submenuTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSubmenu();
      });
    }
    options.forEach(function(option) {
      option.addEventListener('click', function(e) {
        // Check if it's the chat button (Blip integration)
        if (this.hasAttribute('data-action') && this.getAttribute('data-action') === 'open-blip-chat') {
          e.preventDefault();
          
          const optionTitle = this.querySelector('strong');
          const title = optionTitle ? optionTitle.textContent : 'Chat';

          // Track analytics
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
              'event': 'help_option_clicked',
              'option_name': title,
              'option_url': 'blip-chat'
            });
          }

          // Close menu
          container.classList.remove('is-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.setAttribute('aria-label', 'Abrir menu de ajuda');
          content.setAttribute('aria-hidden', 'true');
          
          // Initialize Blip Chat if not already initialized
          initBlipChat();
          
          // Wait for initialization, then trigger Blip Chat
          setTimeout(function() {
            const blipButton = document.querySelector('#blip-chat-open-iframe');
            if (blipButton) {
              blipButton.click();
            } else {
              console.warn('Botão do Blip Chat não encontrado. Aguardando...');
              // Try again after a longer delay
              setTimeout(function() {
                const blipButton = document.querySelector('#blip-chat-open-iframe');
                if (blipButton) {
                  blipButton.click();
                }
              }, 800);
            }
          }, 500);
          return;
        }

        const optionTitle = this.querySelector('strong');
        const title = optionTitle ? optionTitle.textContent : 'Unknown';

        // Track analytics
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'help_option_clicked',
            'option_name': title,
            'option_url': this.href || 'button'
          });
        }

        // Close menu after a short delay for links
        if (this.tagName === 'A') {
          setTimeout(function() {
            container.classList.remove('is-open');
            toggleBtn.setAttribute('aria-expanded', 'false');
            toggleBtn.setAttribute('aria-label', 'Abrir menu de ajuda');
            content.setAttribute('aria-hidden', 'true');
          }, 300);
        }
      });
    });

    // Close on clicking outside
    document.addEventListener('click', function(event) {
      if (!container.contains(event.target)) {
        // Close submenu if open
        if (submenu && submenu.classList.contains('is-open')) {
          submenu.classList.remove('is-open');
          submenuTrigger.setAttribute('aria-expanded', 'false');
          submenu.setAttribute('aria-hidden', 'true');
        }
        
        // Close main menu if open
        if (container.classList.contains('is-open')) {
          container.classList.remove('is-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.setAttribute('aria-label', 'Abrir menu de ajuda');
          content.setAttribute('aria-hidden', 'true');
        }
      }
    });

    // Close on escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        // Close submenu first if open
        if (submenu && submenu.classList.contains('is-open')) {
          submenu.classList.remove('is-open');
          submenuTrigger.setAttribute('aria-expanded', 'false');
          submenu.setAttribute('aria-hidden', 'true');
          submenuTrigger.focus();
        } else if (container.classList.contains('is-open')) {
          // Then close main menu
          container.classList.remove('is-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.setAttribute('aria-label', 'Abrir menu de ajuda');
          content.setAttribute('aria-hidden', 'true');
          toggleBtn.focus();
        }
      }
    });;

    // Keyboard navigation for options
    content.addEventListener('keydown', function(event) {
      if (!container.classList.contains('is-open')) return;

      const focusableElements = Array.from(content.querySelectorAll('a, button'));
      const currentIndex = focusableElements.indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % focusableElements.length;
        focusableElements[nextIndex].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const prevIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
        focusableElements[prevIndex].focus();
      } else if (event.key === 'Home') {
        event.preventDefault();
        focusableElements[0].focus();
      } else if (event.key === 'End') {
        event.preventDefault();
        focusableElements[focusableElements.length - 1].focus();
      }
    });
  });
});
